import { useEffect } from 'react';
import createContextUtilities from '../../utils/createContextUtilities/3841674170c200f7bdd32cb74e68b517c71ba9e78ccd1beac3d76de81e3e2a5c.cfe-internal.js';

var _createContextUtiliti = createContextUtilities({}),
    FormFieldProvider = _createContextUtiliti.Provider,
    useFormFieldContext = _createContextUtiliti.useContext;

var useFormFieldControl = function useFormFieldControl() {
  var context = useFormFieldContext();
  var setHasControl = context.setHasControl;
  useEffect(function () {
    setHasControl === null || setHasControl === void 0 ? void 0 : setHasControl(true);
  }, [setHasControl]);
  return context;
};

var useFormFieldLabel = function useFormFieldLabel() {
  var context = useFormFieldContext();
  var setHasLabel = context.setHasLabel;
  useEffect(function () {
    setHasLabel === null || setHasLabel === void 0 ? void 0 : setHasLabel(true);
  }, [setHasLabel]);
  return context;
};

var useFormFieldType = function useFormFieldType(type) {
  var context = useFormFieldContext();
  var setFormFieldType = context.setFormFieldType;
  useEffect(function () {
    setFormFieldType === null || setFormFieldType === void 0 ? void 0 : setFormFieldType(type);
  }, [setFormFieldType, type]);
  return context;
};

export { FormFieldProvider, useFormFieldContext, useFormFieldControl, useFormFieldLabel, useFormFieldType };
